import * as tslib_1 from "tslib";
import { MatButton } from '@angular/material/button';
import { enumMapper, MachineType, } from '@models';
import { encodeFilters, ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { MachineService } from '@services';
import { BehaviorSubject } from 'rxjs';
import { finalize, } from 'rxjs/operators';
import { MachineModalComponent, MachineRobotVersionsModalComponent, } from './modals';
var ɵ0 = urlStateHandler;
var MachinesPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MachinesPageComponent, _super);
    function MachinesPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.encodeFilters = encodeFilters;
        _this.MachineType = MachineType;
        _this.machineList = enumMapper(MachineType, {
            resourceKey: 'MachineType',
        });
        _this.loadingModal$ = new BehaviorSubject(false);
        _this.isMachinesCreateGranted$ = _this._appState.user.permissions.isGranted('Machines.Create');
        _this._machineService = _this._service;
        return _this;
    }
    MachinesPageComponent.prototype.removeIems = function (items) {
        var _this = this;
        var toDelete = items || this._grid.selectionManager.selected;
        if (toDelete &&
            toDelete.length === 1) {
            _super.prototype.removeItems.call(this, toDelete);
            return;
        }
        var itemsIds = toDelete.map(function (machine) { return machine.id; });
        this._modal.onConfirm(null, function () {
            _this.loading$.next(true);
            _this._machineService.deleteBulk(itemsIds)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function () { return _this._refresh$.next(); });
        }, function () { }, this._translate.instant('grid_action_delete_message'));
    };
    MachinesPageComponent.prototype.openModal = function (type, model) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!model) return [3 /*break*/, 4];
                        this.loadingModal$.next(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._machineService
                                .getInstance(model.id)
                                .toPromise()];
                    case 2:
                        // retrieve the machine key, which is not yet available
                        model = _b.sent();
                        type = MachineType[model.type];
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.loadingModal$.next(false);
                        return [2 /*return*/];
                    case 4:
                        this.loadingModal$.next(false);
                        this._modal
                            .openModal(MachineModalComponent, model, {
                            autoFocus: false,
                            data: {
                                type: type,
                            },
                        })
                            .afterClosedResult()
                            .subscribe(function (res) {
                            switch (res.type) {
                                case 1 /* Add */:
                                case 2 /* Update */:
                                    _this._refresh$.next();
                                    break;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    MachinesPageComponent.prototype.openVersionsModal = function (machine) {
        this._modal
            .openModal(MachineRobotVersionsModalComponent, machine, {
            autoFocus: false,
        });
    };
    MachinesPageComponent.prototype.getMachineNameSuggest = function (entry) {
        return JSON.stringify([
            entry.id,
            entry.name,
        ]);
    };
    return MachinesPageComponent;
}(ODataGridComponent));
export { MachinesPageComponent };
export { ɵ0 };
